var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.idtgrace
    ? _c("div", [
        !_vm.isRaceresultLoaded
          ? _c("div", { staticClass: "loader-holder" }, [_c("loader")], 1)
          : _vm.raceResult
          ? _c("div", { staticClass: "race-info pmraceinfo-wrap" }, [
              _c("div", { staticClass: "race-header" }, [
                _c("div", { staticClass: "race-ttl-line" }, [
                  _c("span", { staticClass: "race-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.raceResult.race.name ||
                          "Race " + _vm.raceResult.race.number
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _vm.raceResult.race.usc === "ON"
                    ? _c(
                        "span",
                        {
                          class:
                            "racetimeticker " +
                            _vm.pmRaceClockCalculate(
                              _vm.raceResult.race.tsstart,
                              _vm.raceResult.timestamp
                            ).cssclass,
                          staticStyle: { float: "right" },
                          attrs: {
                            "data-racetsstart": _vm.raceResult.race.tsstart,
                            "data-racedatastamp": _vm.raceResult.timestamp,
                            "data-raceusc": _vm.raceResult.race.usc
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.pmRaceClockCalculate(
                                _vm.raceResult.race.tsstart,
                                _vm.raceResult.timestamp
                              ).timetostart
                            )
                          )
                        ]
                      )
                    : _c(
                        "span",
                        {
                          staticClass: "racetimeticker racetime-over",
                          staticStyle: { float: "right" }
                        },
                        [_vm._v(_vm._s(_vm.raceResult.race.gsc))]
                      )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "race-info race-info-wrapper race-info-collapsed"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "race-info-line race-info-title" },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.raceResult.meeting.name || "") +
                              " #" +
                              _vm._s(_vm.raceResult.race.number)
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-icon",
                          {
                            staticClass: "icon-race-info",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.toggleRaceInfo()
                              }
                            }
                          },
                          [_vm._v("info")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "race-info-line" }, [
                      _vm._v(
                        _vm._s(
                          _vm.raceResult.race.name ||
                            "Race " + _vm.raceResult.race.number
                        ) +
                          " @ " +
                          _vm._s(
                            _vm.pmFormatStartTs(_vm.raceResult.race.tsstart)
                          )
                      )
                    ]),
                    _vm._v(" "),
                    _vm.raceResult.meeting.weather ||
                    _vm.raceResult.meeting.goingcode
                      ? _c(
                          "div",
                          { staticClass: "race-info-line conditions" },
                          [
                            _c("span", [_vm._v("Conditions: ")]),
                            _vm._v(" "),
                            _vm.raceResult.meeting.weather
                              ? _c("span", [
                                  _vm._v(
                                    " " + _vm._s(_vm.raceResult.meeting.weather)
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.raceResult.meeting.goingcode
                              ? _c("span", [
                                  _vm._v(
                                    ", " +
                                      _vm._s(_vm.raceResult.meeting.goingcode) +
                                      " "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "race-info-line" }, [
                      _vm._v(
                        _vm._s(_vm.$t("Pool.Distance")) +
                          " " +
                          _vm._s(_vm.raceResult.race.distance || "-")
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "icon-close",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.toggleRaceInfo()
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("close")])],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pmtable-holder" }, [
                _c(
                  "table",
                  { staticClass: "pmtable pmrunners pmr-togglable" },
                  [
                    _c("tr", { staticClass: "pmr-togglable-for-state1" }, [
                      _vm.raceResult.race.runners.length > 1
                        ? _c(
                            "th",
                            {
                              staticStyle: {
                                "font-style": "italic",
                                "font-weight": "normal"
                              },
                              attrs: { colspan: "2" }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.raceResult.race.noofrunners) +
                                  " runners - " +
                                  _vm._s(_vm.raceResult.race.runners[0].name) +
                                  ", " +
                                  _vm._s(_vm.raceResult.race.runners[1].name) +
                                  " ..."
                              )
                            ]
                          )
                        : _c(
                            "th",
                            {
                              staticStyle: {
                                "font-style": "italic",
                                "font-weight": "normal"
                              },
                              attrs: { colspan: "2" }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Raceinfo.Runners_jockeys_trainers_info"
                                  )
                                )
                              )
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "pmr-vtoggle-cell",
                          on: {
                            click: function($event) {
                              return _vm.pmrToggle($event)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "pmr-vtoggle" }, [
                            _vm._v("+")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "pmr-togglable-for-state2" }, [
                      _c("th", { staticClass: "pmr-num" }, [_vm._v("#")]),
                      _vm._v(" "),
                      _c("th", [_vm._v("Runner")]),
                      _vm._v(" "),
                      _c(
                        "th",
                        {
                          staticClass: "pmr-vtoggle-cell",
                          on: {
                            click: function($event) {
                              return _vm.pmrToggle($event)
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "pmr-vtoggle" }, [
                            _vm._v("-")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      { staticClass: "pmr-togglable-for-state2" },
                      _vm._l(_vm.raceResult.race.runners, function(runner) {
                        return _c("tr", { staticClass: "pmr-runner" }, [
                          _c("td", { staticClass: "pmr-num" }, [
                            _vm._v(_vm._s(runner.num))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "pmr-info" }, [
                            _c("div", { staticClass: "pmr-name" }, [
                              _vm._v(_vm._s(runner.name))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pmr-jockey" }, [
                              _vm._v(_vm._s(runner.jockey))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "pmr-trainer" }, [
                              _vm._v(_vm._s(runner.trainer))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "pmr-status" }, [
                            runner.runningstatus === "NON_RUNNER"
                              ? _c("span", [
                                  _vm._v(_vm._s(_vm.$t("Runnerpool.SCR")))
                                ])
                              : _vm._e()
                          ])
                        ])
                      }),
                      0
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pmtable-holder" }, [
                _vm.raceResult.race.usc === "ON"
                  ? _c("table", { staticClass: "pmtable greyrows" }, [
                      _c("tr", [
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("Raceinfo.PoolType.Title")))
                        ]),
                        _c("th", { staticClass: "poolmoney" }, [
                          _vm._v(_vm._s(_vm.$t("Racecard.PoolAmount.Title")))
                        ]),
                        _c("th", { staticClass: "poolmoney" }, [
                          _vm._v(_vm._s(_vm.$t("Raceinfo.Carryover.Title")))
                        ]),
                        _c("th")
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        [
                          _vm._l(_vm.raceResult.poolsfordisplay, function(
                            pool
                          ) {
                            return [
                              pool.legs.length > 0 &&
                              pool.legs[0].r === _vm.raceResult.race.idtgrace &&
                              (!pool.bettypes ||
                                !_vm.availableRCTypes.includes(pool.type))
                                ? _c(
                                    "tr",
                                    {
                                      staticClass: "clickable",
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.navToPoolOffer(
                                            _vm.raceResult.meeting.idtgmeeting,
                                            _vm.raceResult.race.idtgrace,
                                            pool.type
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("td", [_vm._v(_vm._s(pool.poolname))]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "poolmoney" },
                                        [
                                          pool.totalpoolvalue
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      pool.totalpoolvalue
                                                    )
                                                  )
                                                )
                                              ]
                                            : [_vm._v("-")]
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { staticClass: "poolmoney" },
                                        [
                                          pool.totalcarriedforward
                                            ? [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      pool.totalcarriedforward
                                                    )
                                                  )
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _vm._m(0, true)
                                    ]
                                  )
                                : pool.legs.length > 0 &&
                                  pool.legs[0].r ===
                                    _vm.raceResult.race.idtgrace &&
                                  pool.bettypes
                                ? _vm._l(pool.bettypes, function(
                                    bettype,
                                    bettypeIx
                                  ) {
                                    return _c(
                                      "tr",
                                      {
                                        staticClass: "clickable",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.navToPoolOffer(
                                              _vm.raceResult.meeting
                                                .idtgmeeting,
                                              _vm.raceResult.race.idtgrace,
                                              pool.type,
                                              bettype.id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.pmTranslateBetType(
                                                pool.type,
                                                bettype.id,
                                                _vm.raceResult.meta,
                                                pool.poolname
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "poolmoney" },
                                          [
                                            bettypeIx === 1
                                              ? [
                                                  pool.totalpoolvalue
                                                    ? [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              pool.totalpoolvalue
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    : [_vm._v("-")]
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "poolmoney" },
                                          [
                                            bettypeIx === 1
                                              ? [
                                                  pool.totalcarriedforward
                                                    ? [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              pool.totalcarriedforward
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ]
                                              : _vm._e()
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _vm._m(1, true)
                                      ]
                                    )
                                  })
                                : _vm._e()
                            ]
                          })
                        ],
                        2
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.raceResult.race.usc === "OFF" &&
              _vm.raceResultWinningRunners.length > 0
                ? _c("table", { staticClass: "pmtable" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", { staticClass: "pmr-num" }, [_vm._v("#")]),
                        _c("th", [
                          _vm._v(_vm._s(_vm.$t("Raceinfo.Runner_Winner.Title")))
                        ]),
                        _c("th", { staticClass: "poolmoney" }, [
                          _vm._v(_vm._s(_vm.$t("Raceinfo.Place_Result.Title")))
                        ]),
                        _c("th", { staticClass: "poolmoney" }, [
                          _vm._v(_vm._s(_vm.$t("Raceinfo.Win.Title")))
                        ]),
                        _c("th", { staticClass: "poolmoney" }, [
                          _vm._v(_vm._s(_vm.$t("Raceinfo.Place.Title")))
                        ]),
                        _c("th", { staticClass: "poolmoney" }, [
                          _vm._v(_vm._s(_vm.$t("Raceinfo.Show.Title")))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.raceResultWinningRunners, function(winrnr) {
                        return _c("tr", { staticClass: "hoverable" }, [
                          _c("td", { staticClass: "pmr-num" }, [
                            _vm._v(_vm._s(winrnr.num))
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(winrnr.name))]),
                          _vm._v(" "),
                          _c("td", { staticClass: "poolmoney" }, [
                            _vm._v(_vm._s(winrnr.placementresult))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "poolmoney" }, [
                            _vm._v(
                              _vm._s(
                                winrnr.guides4display.WIN
                                  ? winrnr.guides4display.WIN.dividend4display
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "poolmoney" }, [
                            _vm._v(
                              _vm._s(
                                winrnr.guides4display.PLACE
                                  ? winrnr.guides4display.PLACE.dividend4display
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "poolmoney" }, [
                            _vm._v(
                              _vm._s(
                                winrnr.guides4display.SHOW
                                  ? winrnr.guides4display.SHOW.dividend4display
                                  : ""
                              )
                            )
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.raceResult.race.usc === "OFF" &&
              _vm.raceResultPoolDividends &&
              _vm.raceResultPoolDividends.length > 0
                ? _c("table", { staticClass: "pmtable" }, [
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("Raceinfo.Pool_Offers.Title")))
                      ]),
                      _c("th", { staticClass: "poolmoney" }, [
                        _vm._v(_vm._s(_vm.$t("Raceinfo.Combination.Title")))
                      ]),
                      _c("th"),
                      _c("th", { staticClass: "poolmoney" }, [
                        _vm._v(_vm._s(_vm.$t("Raceinfo.Pays.Title")))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.raceResultPoolDividends, function(pool) {
                        return _c("tr", { staticClass: "hoverable" }, [
                          _c("td", [_vm._v(_vm._s(pool.poolname))]),
                          _vm._v(" "),
                          _c("td", { staticClass: "poolmoney" }, [
                            _vm._v(_vm._s(pool.resultcombination || "-"))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "poolmoney narrow" }, [
                            _vm._v(_vm._s(pool.resultdividend ? "$1" : ""))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "poolmoney narrow" }, [
                            _vm._v(_vm._s(pool.resultdividend || "-"))
                          ])
                        ])
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.raceResult.race.usc === "OFF"
                ? _c("table", { staticClass: "pmtable" }, [
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("Raceinfo.Scratches.Title")))
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.raceResult.race.runners.filter(function(scrrnr) {
                      return scrrnr.runningstatus === "NON_RUNNER"
                    }).length < 1
                      ? _c("tr", [
                          _c("td", [_vm._v(_vm._s(_vm.$t("Raceinfo.None")))])
                        ])
                      : _c("tr", [
                          _c(
                            "td",
                            [
                              _vm._l(
                                _vm.raceResult.race.runners.filter(function(
                                  scrrnr
                                ) {
                                  return (
                                    scrrnr.runningstatus &&
                                    scrrnr.runningstatus === "NON_RUNNER"
                                  )
                                }),
                                function(rnr, rnrIx) {
                                  return [
                                    rnrIx > 0 ? [_vm._v(", ")] : _vm._e(),
                                    _vm._v(_vm._s(rnr.entrynumber))
                                  ]
                                }
                              )
                            ],
                            2
                          )
                        ])
                  ])
                : _vm._e()
            ])
          : _c("div", [
              _vm._v("\n    " + _vm._s(_vm.$t("Raceinfo.NoData")) + "\n  ")
            ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "rpointer" }, [
      _c("span", { staticClass: "icon-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "rpointer" }, [
      _c("span", { staticClass: "icon-right" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d0b1e26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0b1e26","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parimutuel/betting/RaceInfo.vue
// module id = null
// module chunks = 